import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router, ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs/Observable';


@Injectable()
export class AuthGuard implements CanActivate {

  constructor(private router: Router, private route: ActivatedRoute) {
    console.log("jchkshc")
    // this.route.queryParams
    //   .filter((params) => params.utm_source)
    //   .subscribe((params) => {
    //     console.log(params); // {order: "popular"}
    //     if (params.utm_source != null) {
    //       console.log("hsg")
    //       //  this.ppavl = true;
    //     }
    //   });
  }



  canActivate(): Observable<boolean> | Promise<boolean> | boolean {
    if (localStorage.getItem('isLoggedin')) {
      return true;
    }
    this.router.navigate(['/login']);
    return false;
  }
}



// WEBPACK FOOTER //
// C:/Ajatus WorkSpace/Now Grocery/now-grocery/NowGroceryStoreFront/src/app/app-route.guard.ts